/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo } from 'react';
const CardDescList = ({ row, hiddenColumns, }) => {
    const displayedCells = useMemo(() => {
        const base = row.cells.slice(1);
        const showAll = !(hiddenColumns === null || hiddenColumns === void 0 ? void 0 : hiddenColumns.length);
        // return all cells - none hidden
        if (showAll)
            return base;
        // return visible cells - some hidden
        return base.reduce((acc, cell) => {
            const { column } = cell;
            const shouldShow = !hiddenColumns.includes(column.id);
            if (shouldShow) {
                return [...acc, cell];
            }
            return acc;
        }, []);
    }, [row, hiddenColumns]);
    return (React.createElement("dl", null, displayedCells.map((cell) => {
        const { column } = cell;
        return (React.createElement("div", { key: column.id },
            React.createElement("dt", null, column.render('Header')),
            React.createElement("dd", { "data-private": cell.column.isPrivate }, cell.render('Cell'))));
    })));
};
export { CardDescList };
//# sourceMappingURL=CardDescList.js.map